'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var zh_CN = {
    // www
    www_title: '小微便签',
    update_log: '更新日志',
    slogan_text1: '小微便签致力于方便、快捷记录琐事和智能任务提醒。',
    slogan_text2: '重要、琐碎的事情不遗忘，让工作和生活变得井井有条，开启效率人生。',
    slogan_text3: '可以在多设备间即时云同步。（Windows&Mac版本正在开发中）',
    slogan_h5: '小微便签致力于方便、快捷记录琐事和智能任务提醒。重要、琐碎的事情不遗忘，让工作和生活变得井井有条，开启效率人生。可以在多设备间即时云同步，（Windows&Mac版本正在开发中）',
    android_download: '下载APP',
    ios_download: 'AppStore安装',
    support_system: '已支持如下平台',
    windows_button: 'Windows版',
    mac_button: 'Mac版',
    iphone_button: 'iPhone版',
    android_button: '安卓版',
    scan_download_phone: '扫描二维码下载手机客户端',
    content_title1: '多个设备之间即时同步',
    content_text1: '您可以在iPhone&iPad&安卓手机&安卓Pad之间，即时同步便签以及内容。（Windows&Mac版本正在开发中）',
    content_title2: '丰富精品便签样式',
    content_text2: '为您精心准备了几十款便签样式，丰富多彩的记录内容，让记录不再单调',
    content_title3: '多种主题背景选择',
    content_text3: '为您精心准备了几十款便签样式，换一换背景，换一换主题，换一换心情',
    content_title4: '精美小组件',
    content_text4: '可以将您的便签放在手机桌面上，方便快速浏览，快速记录，效率人生',
    content_title5: '自定义通知提醒',
    content_text5: '丰富的提醒设置，可以随意自定义您想要提醒的时间，生日、聚会、重要的事情不再遗忘',
    content_title6: '周计划，月计划',
    content_text6: '将计划分类定制，合理方便查看、记录您的琐事',
    support: '客户支持',
    support_title: '小微便签-客戶支持',
    support_text1: '如果您有任何意见和建议，敬请邮件联系我们\n',
    support_text2: '欢迎加入我们 QQ 群一起讨论产品。\n  安卓系统群：',
    support_text3: '\n 苹果系统群：',
    help: '帮助'
};
exports["default"] = zh_CN;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/zh_CN.js
// module id = 271
// module chunks = 0